import {
  AccountDetail,
  AccountType,
  CommPreference,
  PremiseInfo,
} from '../../../../__generated__/pge-types';
import { isEmpty } from 'lodash';
import { AccountWithOutageInfo } from '../../types';
import { MultiPolygon, Polygon } from 'geojson';

export const getAccountsByType = (
  accounts: AccountWithOutageInfo[],
  accType: AccountType,
) => {
  return accounts?.filter(account => {
    const isResidential = accType === AccountType.Res;
    const hasPremiseInfo = account?.premiseInfos?.some(
      p => p?.isEligibleForOutage,
    );

    const isMatchingAccType = isResidential
      ? account.accountType === AccountType.Res
      : account.accountType !== AccountType.Res; // if a account is not Residential then it is a commercial account

    return isMatchingAccType && account.isActive && hasPremiseInfo;
  });
};

export const getReportedOutageAccountInfo = (
  account: AccountDetail,
): AccountWithOutageInfo | null => {
  const {
    isDefault,
    premiseInfo,
    accountNumber,
    encryptedPersonId,
    pspsOutage,
    isActive,
  } = account;

  const validPremiseInfos =
    premiseInfo &&
    premiseInfo.filter(
      currPremiseInfo =>
        currPremiseInfo?.isEligibleForOutage &&
        currPremiseInfo?.servicePointDetails &&
        currPremiseInfo.servicePointDetails.length > 0,
    );

  if (!validPremiseInfos) {
    return null;
  }

  const outageReportedPremiseInfo = premiseInfo?.find(premise => {
    return premise?.servicePointDetails
      ? premise?.servicePointDetails?.filter(point => {
          return point?.outageInfo?.hasKnownOutage;
        }).length > 0
      : [];
  });

  const commPrefs: CommPreference[] | undefined = account.commPreferences
    ? account?.commPreferences?.filter((c): c is CommPreference => !!c)
    : undefined;
  return {
    isActive,
    isPrimaryAccount: isDefault,
    hasKnownOutage: !isEmpty(outageReportedPremiseInfo),
    description: account.description || accountNumber,
    accountNumber,
    premiseInfos: premiseInfo ? (premiseInfo as PremiseInfo[] | undefined) : [],
    commPreferenceInfo: commPrefs,
    encryptedPersonId,
    addressLocation: outageReportedPremiseInfo
      ? outageReportedPremiseInfo?.addressLine1 +
        ', ' +
        outageReportedPremiseInfo.city +
        ', ' +
        outageReportedPremiseInfo.state +
        ' ' +
        outageReportedPremiseInfo.postal
      : premiseInfo[0]?.addressLine1 +
        ', ' +
        premiseInfo[0]?.city +
        ', ' +
        premiseInfo[0]?.state +
        ' ' +
        premiseInfo[0]?.postal,
    mainCustomerName: account.mainCustomerName,
    accountType: account.accountType,
    pspsOutage: pspsOutage || undefined,
  };
};

export function getPolygonCenter(
  geometry: Polygon | MultiPolygon,
): [number, number] {
  const coords =
    geometry.type === 'Polygon'
      ? geometry.coordinates.flat()
      : geometry.coordinates.flat(2);

  const total = coords.reduce(
    (acc, [lng, lat]) => {
      acc.lng += lng;
      acc.lat += lat;
      return acc;
    },
    { lng: 0, lat: 0 },
  );

  const count = coords.length || 1;
  return [total.lng / count, total.lat / count];
}
